export enum TAX_TYPE {
  GUIDE = 'GUIDE', //기본 타입
  DEFAULT = 'DEFAULT', //기본 타입
  BEFORE_SENDING_BILL = 'BEFORE_SENDING_BILL', //고지서 발송 전 타입
  OUT_PAYMENT_PERIOD = 'OUT_PAYMENT_PERIOD', //날부월 외 타입
  NOT_APPLY_SERVICE = 'NOT_APPLY_SERVICE', //전자문서 서비스 신청 안한 경우
  OTHER_SERVICE_ID = 'OTHER_SERVICE_ID', //전자문서 서비스 신청한 다른 아이디가 있는 경우
}

export enum TAX_BILLED_TYPE {
  NONE = 'NONE',
  PROPERTY_TAX = '재산세(주택)', //재산세
  RESIDENT_TAX = '주민세(개인균등주소지할)', //주민세
}

export enum TAX_BILLED_STATUS {
  NON_PAYMENT = 'NON_PAYMENT', //미납부
  CHECK_FAILED = 'CHECK_FAILED', //납부확인실패
  AUTOMATIC_BILLING = 'AUTOMATIC_BILLING', //자동납부
  COMPLETE = 'COMPLETE', //납부완료
}

export const TAX_BILLED_STATUS_OBJ = {
  [TAX_BILLED_STATUS.NON_PAYMENT]: {
    CODE: TAX_BILLED_STATUS.NON_PAYMENT,
    LABEL: '미납부',
  },
  [TAX_BILLED_STATUS.CHECK_FAILED]: {
    CODE: TAX_BILLED_STATUS.CHECK_FAILED,
    LABEL: '납부확인 실패',
  },
  [TAX_BILLED_STATUS.AUTOMATIC_BILLING]: {
    CODE: TAX_BILLED_STATUS.AUTOMATIC_BILLING,
    LABEL: '자동납부',
  },
  [TAX_BILLED_STATUS.COMPLETE]: {
    CODE: TAX_BILLED_STATUS.COMPLETE,
    LABEL: '납부 완료',
  },
}

type TaxList = {
  [key: string]: any
}

export const TAX_LIST_ORDER: TaxList = {
  NON_PAYMENT: 1,
  CHECK_FAILED: 2,
  AUTOMATIC_BILLING: 3,
  COMPLETE: 4,
}

export const DEFAULT_TAX_LIST_COUNT = 3
